export enum VersionableType {
  CLIENT,
  TEXTILE,
  MACHINE,
  PRODUCTION,
  MESSAGING,
  WORKER
}
